module.exports = __webpack_public_path__ + "static/img/smith-farm-historical-signs17.81e2df7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/smith-farm/smith-farm-historical-signs17.jpg
// module id = 972
// module chunks = 0